import request from '@/util/request';

// 获取坐席信息
export const getOperatorInfoApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/server/getServerInfo',
    Object.assign({}, options, { params })
  );

// 上号
export const loginApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/login', params, options, {
    'Content-Type': 'application/json',
  });

// 下号|离线|签退
export const logoutApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/logout', params, options, {
    'Content-Type': 'application/json',
  });

// 就绪
export const readyApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/ready', params, options, {
    'Content-Type': 'application/json',
  });

// 离开
export const awayApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/leave', params, options, {
    'Content-Type': 'application/json',
  });

// 拨打电话
export const callApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/connectExt2Outer', params, options, {
    'Content-Type': 'application/json',
  });

// 挂断电话
export const hangUpApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/clear', params, options, {
    'Content-Type': 'application/json',
  });

// 驻留
export const holdApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/hold', params, options, {
    'Content-Type': 'application/json',
  });

// 拾回
export const unHoldApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/unHold', params, options, {
    'Content-Type': 'application/json',
  });

// 满意度
export const evaluateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/evaluate', params, options, {
    'Content-Type': 'application/json',
  });

// 来电转分机-转内线
export const transferApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/connectVisitor2Ext', params, options, {
    'Content-Type': 'application/json',
  });

// 来电转分机-转外线
export const transferOutLineApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/connectVisitor2Outer', params, options, {
    'Content-Type': 'application/json',
  });

// 监听
export const listenApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/monitor', params, options, {
    'Content-Type': 'application/json',
  });

// 从监听切换到插播(屏蔽一方的双方通话)
export const insertFromListenApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/monitor/talk', params, options, {
    'Content-Type': 'application/json',
  });

// 从插播回到监听状态
export const listenFromInsertApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/monitor/listen', params, options, {
    'Content-Type': 'application/json',
  });

// 强插(三方通话)
export const insertApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/bargein', params, options, {
    'Content-Type': 'application/json',
  });

// 强拆-->实际是挂断电话
export const abortApi = (params, options) =>
  request.post('/api/v4ward/callcenter/om/clear', params, options, {
    'Content-Type': 'application/json',
  });

// 获取客户详情
export const getCustomerDetailApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/call/record/customer',
    Object.assign({}, options, { params })
  );

// 获取跟进记录列表
export const getRecordsApi = (params, options) =>
  request.get('/api/v4ward/callcenter/call/record/list', Object.assign({}, options, { params }));

// 获取跟进记录详情
export const getRecordDetailApi = (params, options) =>
  request.get('/api/v4ward/callcenter/call/record/detail', Object.assign({}, options, { params }));

// 保存跟进记录详情
export const saveRecordApi = (params, options) =>
  request.post('/api/v4ward/callcenter/call/record/submit', params, options, {
    'Content-Type': 'application/json',
  });

// 获取有内容记录的记录列表
export const getMsgListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/call/record/descriptionList', Object.assign({}, options, { params }));

// 获取有关联工单的记录列表
export const getOrderListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/call/record/orderList', Object.assign({}, options, { params }));

// 获取坐席列表
export const getOperatorsApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/server/workstatus/list',
    Object.assign({}, options, { params })
  );
